import { getTranscriptSeekOffset } from './callDetail.utils';
import type { ConversationLogDto } from '@shared/services/conversationApiService/apiService';

type TranscriptPositionMessage = Pick<ConversationLogDto, 'createdAt' | 'type'>;

export const getActiveTranscriptIndex = (
  messages: TranscriptPositionMessage[],
  currentTime: number,
  callStartedAt?: string | null,
  audioDuration?: number,
): number | null => {
  if (!Number.isFinite(currentTime) || currentTime < 0) return null;

  let activeIndex: number | null = null;
  messages.forEach((message, index) => {
    if (message.type === 'tool_call') return;
    const offset = getTranscriptSeekOffset(message.createdAt, callStartedAt, audioDuration);
    if (offset !== null && offset <= currentTime) activeIndex = index;
  });
  return activeIndex;
};
